import React from "react";
import { FaPlus } from "react-icons/fa";

function DefiWalletHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-8 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  DeFi Wallet Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    At Xeer Technology, we specialize in developing advanced,
                    secure, and customizable DeFi wallets that empower users to
                    interact seamlessly with decentralized finance (DeFi)
                    platforms.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DefiWalletHero;
